var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{on:{"openMenu":_vm.openMenu}}),(!_vm.isLogin)?_c('BaseModal',{attrs:{"title":_vm.title,"text":_vm.text}}):_vm._e(),(_vm.showMenu)?_c('Menu',{on:{"closeMenu":_vm.closeMenu,"routeChanged":_vm.routeChangeHandler}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }